/**
 * 마감월 표기 헬퍼
 *
 * 저장 포맷은 'YYYY-MM'으로 통일되어 있으나(마이그레이션 expense 0020 이전
 * 데이터에는 '8', '08' 같은 값이 남아 있을 수 있음), 지출결의서 등
 * 출력물에는 월만 표기한다. 예) '2026-08' -> '08월'
 *
 * @param {string|number|null|undefined} value 마감월 원본값
 * @returns {string} '08월' 형태. 값이 없으면 '-', 해석 불가하면 원본 문자열.
 */
export function formatCloseMonthShort(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '-';

  const m = raw.match(/(\d{1,2})\s*월?$/);
  if (!m) return raw;

  const month = Number(m[1]);
  if (!Number.isInteger(month) || month < 1 || month > 12) return raw;

  return `${String(month).padStart(2, '0')}월`;
}

export default formatCloseMonthShort;
